import React, {useState, Fragment, useCallback, Suspense, useContext, useEffect} from 'react';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,TabContent, TabPane, Row, Nav, NavItem, Col, NavLink } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../AbstractElements';
import Loader from '../../../Layout/Loader'
import DataTable from 'react-data-table-component';
// import { inventorytabledata, tableColumns } from '../../../Data/Inventory';
import { useNavigate } from 'react-router';
import classnames from 'classnames'
import { DeleteInventory, InventoryCategoryList, InventoryList } from '../../../apiController';
import { Navigator } from '../../../Data/Table/Defaultdata';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { roles_permissions } from '../../../Layout/Sidebar/Menu';

const InventoryIndex = () =>{

  const navigate = useNavigate()

  const permission = roles_permissions.find(
    (module) => module.module_name === "Inventory"
  );

  console.log(permission)

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };
  const clearSearchTab = () => {
    setSearchKeyword("");
};

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState();
    const [inventory, setInventory] = useState([]);
    const [inventoryCategory, setInventoryCategory] = useState([]);

  const [currentActiveTab, setCurrentActiveTab] = useState('1'); 

	// Toggle active state for Tab 
	const toggle = tab => { 
		if (currentActiveTab !== tab) 
      setCurrentActiveTab(tab);
    fetchFilterdInventory(tab) 

    if (tab === ''){
      fetchInventory()
    }
	} 

  const searchedInventory = inventory
  .filter(
      (c) =>
          (c.material_name?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) ||
          (c.make?.toLowerCase() ?? '').includes(searchKeyword.toLowerCase()) 
  )
  .reverse();

  const inventorytabledata = searchedInventory.map(((row, ind)=>(
    {
        ind:ind+1,
        id: row.id,
        // category: row.ca ,
        materialname: row.material_name,
        make: row.make,
        stockavailable: row.stock_in,
        stockout: row.stock_out,
        status: row.category_name === 'Instruments'? row.condition_status: 'NA',
        action: <span>
        {/* <Btn attrBtn={{ style: style2, color: 'success', className: 'btn btn-xs', type: 'button' }}>Edit </Btn> */}
        <Navigator to={`${process.env.PUBLIC_URL}/inventoryform/:layout`} params={{ rowData: row , btn: "edit"}}/>
      </span>
        // budget: '$3142.00',

    })
  )
);

 const tableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: true,
    },
    // {
    //     name: 'Category',
    //     selector: row => row['category'],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: 'Material Name',
        selector: row => row['materialname'],
        sortable: true,
        center: true,
    },
    {
      name: 'Make',
      selector: row => row['make'],
      // selector: row => `${row.make}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Stock Available',
      selector: row => `${row.stockavailable}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Stock Out',
      selector: row => `${row.stockout}`,
      sortable: true,
      center: true,
  },
    {
      name: 'Status',
      selector: row => `${row.status}`,
      sortable: true,
      center: true,
  },
    // {
    //     name: 'Action',
    //     selector: row => row['action'],
    //     sortable: false,
    //     center: true,
    // },
];

if (permission?.edit_access) {
  tableColumns.push({
    name: "Action",
    selector: (row) => row["action"],
    sortable: false,
    center: true,
  });
}

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteInventory(id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchInventory()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };


    const fetchInventory = async () => {
      const response = await InventoryList();
      if (response.status === true) {
        setInventory(response.data);
      }
    };
    const fetchFilterdInventory = async (id) => {
      const response = await InventoryList();
      if (response.status === true) {
        const filteredInventoryList = response.data.filter(item => item.category_id.toString() === id.toString());
        setInventory(filteredInventoryList);
      }
    };
    const fetchInventoryCategory = async () => {
      const response = await InventoryCategoryList();
      if (response.status === true) {
        setInventoryCategory(response.data);
      }
    };

    useEffect(()=>{
      fetchInventory()
      fetchInventoryCategory()
    },[])
  return (
    <Suspense fallback={<Loader/>}>
      
      
    <Card>
       <Breadcrumbs mainTitle='Inventory' parent='Dashboard' title='inventory' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            value={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
          <span className="input-group-text"
            onClick={() => clearSearchTab()}>
              <i className="fa fa-times" aria-hidden="true"></i>
              </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
         {permission?.create_access &&  <div className='card-header-right-icon'>
            <div className='card-header-right-icon'>
            <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary', onClick: ()=> navigate(`${process.env.PUBLIC_URL}/inventoryform/:layout`)}}>+ Add Inventory</Btn>
          </div>
          </div>}
        </div>
        <div className='mt-5'>
        <Nav tabs fill pills> 
				<NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === '1'
						})} 
						onClick={() => { toggle('1'); }} 
					> 
						All
					</NavLink> 
				</NavItem> 
        {inventoryCategory.map((row,ind)=>
          <NavItem key={row.id}> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === ind+1
						})} 
						onClick={() => { toggle(row.id); }} 
					> 
						{row.name} 
					</NavLink> 
				</NavItem> 
        )}
				{/* <NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === '2'
						})} 
						onClick={() => { toggle('2'); }} 
					> 
						Tab2 
					</NavLink> 
				</NavItem> 
				<NavItem> 
					<NavLink 
						className={classnames({ 
							active: 
								currentActiveTab === '3'
						})} 
						onClick={() => { toggle('3'); }} 
					> 
						Tab3 
					</NavLink> 
				</NavItem>  */}
			</Nav>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={inventorytabledata}
                columns={tableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows ={permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
    </Suspense>
  );
}

export default InventoryIndex